import { redirect } from "next/navigation";
import { BASE_URL } from "@/constants";
import { FormState, HelpFormSchema } from "@/app/[locale]/help/definition";

export async function help(
  state: FormState,
  formData: FormData,
): Promise<FormState> {
  const validatedFields = HelpFormSchema.safeParse({
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    email: formData.get("email"),
    mobileNumber: formData.get("mobileNumber"),
    deviceModel: formData.get("deviceModel"),
    iccid: formData.get("iccid"),
    message: formData.get("message"),
  });

  // If any form fields are invalid, return early
  if (!validatedFields.success) {
    console.log(validatedFields.error.flatten().fieldErrors);
    return {
      errors: validatedFields.error.flatten().fieldErrors,
    };
  }

  // 2. Prepare data for insertion into database
  const res = await fetch(BASE_URL + "tickets/submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...validatedFields.data }),
  });

  const data = await res.json();

  if (data.message) {
    return { error: data.message };
  } else {
    return {success: 'ok'}
  }
}
